<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">備註</h3>
        </div>
        <div class="modal-body send-modal-body" style="min-height:180px;">
           <div v-html="comment">
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'

export default {
  name: 'CommentModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    comment: {
        type: String,
        default: ''
    }
  },
  data() {
      return {}
  },
  methods: {
      submit() {
          this.$emit('close');
      }
  },
  computed: {
  }
}
</script>
